var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-item"},[_c('div',{staticClass:"flex flex-dir-column flex-justify-center"},[_c('i',{staticClass:"el-icon-document file-icon"}),_c('div',{staticClass:"file-title"},[_vm._v(_vm._s(_vm.file.url.slice(_vm.file.url.lastIndexOf('.') + 1)))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }